import { RegionFile } from './types'

let regionDictionary: Record<string, Record<string, string>> | null = null
let regionFile: RegionFile | undefined = undefined
let regionData: string[] | null = null
let regionIndex: Record<string, number[]> | null = null

async function getRegionFile () {
  if (!regionFile) {
    regionFile = await import('./assets/region2.json')
  }
  return regionFile
}

export async function data (): Promise<string[]> {
  if (!regionData) {
    let file = regionFile
    if (!file) {
      file = await getRegionFile()
    }
    regionData = file.data
    regionDictionary = file.dictionary!
  }
  return regionData ?? []
}

export async function dictionary (): Promise<Record<string, Record<string, string>>> {
  if (!regionDictionary) {
    let file = regionFile
    if (!file) {
      file = await getRegionFile()
    }
    regionData = file.data
    regionDictionary = file.dictionary!
  }
  return regionDictionary!
}

export async function index (): Promise<Record<string, number[]>> {
  if (!regionIndex) {
    const file = await getRegionFile()
    regionIndex = file.index
  }
  return regionIndex ?? {}
}
